module.exports = __webpack_public_path__ + "img/top_bg.6b2d45b6.png";